import { CreateTask, Timestamp } from '@griply/types';
import { createContext } from 'react';

export type CreateMultipleTasksDialogContextProps = {
  onOpenDialog: (
    taskNames: string[],
    onSubmit: (tasks: CreateTask[]) => Promise<void> | void,
    options?: {
      date?: Timestamp;
      context?: CreateTask;
      onCancel?: () => void;
    },
  ) => void;
};

export const CreateMultipleTasksDialogContext =
  createContext<CreateMultipleTasksDialogContextProps>({
    onOpenDialog: () => {},
  });
